export default __webpack_public_path__ + "static/media/dabur.a8146403.png";